<template>
<div class="container-fluid">
    
    <vue3treevue :items="items" :selectedItems="selectedItems"
                   :isCheckable="false"
                   :hideGuideLines="false" isNested="true" />
</div>
</template>

<script>
import vue3treevue from 'vue3-tree-vue'
export default {
    components: {
        vue3treevue 
  },
    data: () => ({
        selectedItems:{},
        items:[],
        selectedItems1:[]
  }),
  mounted(){
    this.items=[
            this.item([this.item([this.item(null,"GGGGG","g","")],"BBBB","a","folder")],"AAAA","a","folder"),
            this.item([this.item([],"VVVV","v","file"),this.item([],"hhhh","hhhh","file")],"CCCC","v","folder")
    ]
  },
  methods:{
    item(children,Name,id,type){
        return {"children":children,"name":Name,"id":id,"type":type,"checkedStatus":false}
    }
  }
}
</script>

<style>
 
</style>